<template>
    <div id="setting">
        <div class="main">
            <div class="setting">
                <div class="store-title bg-white padding">
                    <div style="width:130px">
                        <img v-if="storeInfo.platformCode === 'SP'" style="width:100%"
                            src="@/assets/img/store-logo/shopify.png" alt="" />
                        <img v-if="storeInfo.platformCode === 'DJ'" style="width:100%"
                            src="@/assets/img/store-logo/shoplazza.png" alt="" />
                        <img v-if="storeInfo.platformCode === 'SL'" style="width:100%"
                            src="@/assets/img/store-logo/shopline.png" alt="" />
                        <img v-if="storeInfo.platformCode === 'WC'" style="width:100%"
                            src="@/assets/img/store-logo/woocommerce.png" alt="" />
                    </div>
                    <div class="f">
                        <div>
                            <span class="label font">店铺名称：</span>
                            <span class="info font">{{ storeInfo.storeName }}</span>
                        </div>
                        <div style="margin-left:80px">
                            <span class="label font">是否授权：</span>
                            <span class="info font">{{ storeInfo.authorizeStatus === 1 ? "已授权" : "未授权" }}</span>
                        </div>
                    </div>
                    <div>
                        <span class="label font">店铺链接：</span>
                        <span class="info font">{{ storeInfo.storeUrl }}</span>
                    </div>
                </div>

                <div class="padding bg-white product-rule_1">
                    <el-checkbox v-model="storeInfo.isTax" :true-label='1' :false-label='0'
                        class="title">产品是否收税</el-checkbox>
                    <p class="label font">指定在销售产品变体时是否收取税费</p>
                </div>

                <div class="product-rule_1 bg-white padding">
                    <p class="title">产品规则</p>
                    <p class="label font">关联到您店铺的商品SKU的库存发生变化时,请选择一个操作</p>
                    <el-radio-group v-model="storeInfo.isAutoInventory">
                        <el-radio :label="0">关联到您店铺的商品SKU的库存发生变化时,请选择一个操作</el-radio>
                        <el-radio :label="1">自动更新商店 SKU 库存</el-radio>
                    </el-radio-group>
                </div>

                <div class="product-rule_2 bg-white padding">
                    <p class="title">价格规则</p>
                    <el-tooltip class="item" effect="dark" content="Currency is automatically obtained from shopify store"
                        placement="bottom-start">
                        <i style="color:#747a87" class="iconfont iconhelp"></i>
                    </el-tooltip>
                    <span style="margin-left:5px" class="info font">店铺币种</span>
                    <el-input v-model="storeInfo.currency" disabled class="margin-l" style="width:160px"></el-input>

                    <div style="height:54px;width:800px">
                        <el-checkbox v-model="storeInfo.isPrice" :true-label='1' :false-label='0'
                            class="label font priceCheckbox">建议售价</el-checkbox>
                        <span class="font info" v-if="storeInfo.isPrice === 1">
                            <span>产品成本</span>
                            <span class="margin-l">×</span>
                            <el-input-number v-model="storeInfo.priceRatio" class="margin-l" :min="0.1" style="width:120px"
                                ></el-input-number>

                            <span class="margin-l">+</span>
                            <span class="margin-l">运费</span>
                            <span class="margin-l"> = </span>
                            <span class="margin-l">建议售价 </span>
                        </span>
                    </div>

                    <div style="height:54px;width:800px">
                        <el-checkbox v-model="storeInfo.isComparePrice" :true-label='1' :false-label='0'
                            class="label font priceCheckbox">比较价格</el-checkbox>
                        <span class="font info" v-if="storeInfo.isComparePrice === 1"></span>
                        <span>产品成本</span>
                        <span class="margin-l">×</span>
                        <el-input-number v-model="storeInfo.compareRatio" class="margin-l" :min="0.1" style="width:120px"
                            ></el-input-number>
                        <span class="margin-l">+</span>
                        <span class="margin-l">运费</span>
                        <span class="margin-l"> = </span>
                        <span class="margin-l">比较价格</span><br />
                    </div>
                </div>

                <div class="order-rules bg-white padding">
                    <p class="title">订购规则</p>
                    <p class="label font">当店铺的订单发货供应商发货时，请选择一个操作</p>
                    <el-radio-group class="font info" v-model="storeInfo.isDeliverMark">
                        <el-radio :label="0">不操作</el-radio>
                        <el-radio :label="1">自动上传物流单号到店铺</el-radio>
                    </el-radio-group>
                    <p class="label font">当您的商店收到新的等待订单时，是否自动购买</p>
                    <el-radio-group class="font info" v-model="storeInfo.isAutoPurchase">
                        <el-radio :label="0">不自动购买</el-radio>
                        <el-radio :label="1">自动购买</el-radio>
                    </el-radio-group>
                    <p class="label font">默认物流方式</p>
                    <el-radio-group class="font info" v-model="storeInfo.shippingMethod">
                        <el-radio :label="0">Standard</el-radio>
                        <el-radio :label="1">Faster</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import API from '@/api'
export default {
    data() {
        return {
            radio: '',
            currency: [],
            input: '',
            value: '',
            storeInfo: {
                isAutoPurchase: '',
                shippingMethod: '',
                isAutoInventory: '',
                isPrice: '',
                priceRatio: '',
                isDeliverMark: '',
                isComparePrice: '',
                compareRatio: '',
                isTax: ''
            }
        }
    },
    props: ['storeId'],
    created() {
        this.getStoreDetail()
    },
    watch: {
        storeId(newVal, oldVal) {
            if (oldVal && newVal != oldVal) {
                this.getStoreDetail()
            }
        }
    },
    methods: {
        getStoreDetail() {
            API.getStoreSetting(this.storeId).then(res => {
                this.storeInfo.authorizeStatus = res.data.authorizeStatus
                this.storeInfo.platformCode = res.data.platformCode
                this.storeInfo.platformName = res.data.platformName
                this.storeInfo.storeId = res.data.storeId
                this.storeInfo.currency = res.data.currency || 'USD'
                this.storeInfo.isTax = res.data.isTax !== undefined ? res.data.isTax : 0
                this.storeInfo.storeName = res.data.storeName
                this.storeInfo.storeStatus = res.data.storeStatus
                this.storeInfo.storeUrl = res.data.storeUrl
                this.storeInfo.userId = res.data.userId
                this.storeInfo.isAutoPurchase = res.data.isAutoPurchase !== undefined ? res.data.isAutoPurchase : 0
                this.storeInfo.shippingMethod = res.data.shippingMethod ? res.data.shippingMethod : 0
                this.storeInfo.isAutoInventory = res.data.isAutoInventory !== undefined ? res.data.isAutoInventory : 1
                this.storeInfo.isPrice = res.data.isPrice !== undefined ? res.data.isPrice : 1
                this.storeInfo.isComparePrice = res.data.isComparePrice !== undefined ? res.data.isComparePrice : 0
                this.storeInfo.isDeliverMark = res.data.isDeliverMark !== undefined ? res.data.isDeliverMark : 1
                this.storeInfo.compareRatio = res.data.compareRatio
                this.storeInfo.priceRatio = res.data.priceRatio ? res.data.priceRatio : '1.5'
                this.$forceUpdate()
            }).catch(result => {
                this.$message.error(result.data.message)
            })
        }
    }
}
</script>
  
<style lang="scss" scoped>
#setting {
    font-family: Arial;
    // margin: 0 34px;
    min-height: 100vh;

    span {
        display: inline-block;
    }
}

.padding {
    padding: 28px 0 25px 44px;
}

.page-title {
    display: inline-block;
    font-size: 18px;
    line-height: 27px;
    font-weight: 600;
    padding-bottom: 20px;
}

.product-rule_1 {
    margin: 10px 0;
}

.product-rule_2 {
    margin-bottom: 10px;
}

.font {
    font-size: 14px;
    line-height: 20px;
    padding-bottom: 18px;
}

.title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    margin-bottom: 20px;
}

.label {
    color: #747a87;
}

.info {
    color: #10141d;
}

/deep/.el-input__inner {
    height: 36px;
}

/deep/.el-input-number__decrease {
    border-radius: 18px 0 0 18px;
}

/deep/.el-input-number__increase {
    border-radius: 0 18px 18px 0;
}

.margin-l {
    display: inline-block;
    margin-left: 10px;
}

.priceCheckbox {
    padding: 16px 0 0 0;
    margin: 0 30px 0 0;
}

/deep/.el-button--success {
    border-color: none;
    border: none;
    background: #99c41c;
}
</style>
  